module.exports = __webpack_public_path__ + "img/isporuka.d0b41b64.png";